module.exports = __webpack_public_path__ + "static/media/Wework-paintbrush.5fd419cb.svg";